export default {
  pwkit: {
    title: 'Introduction',
    titleP1:`
    PWkit is a pre- and post-processing tool developed for PWmat software.
    It currently includes three modules: Generator, Module and Utility (under development...).
    `,
    titleP2:`
    Generator: Generates the input file etot.input for PWmat based on optional
    parameters (task type, functional settings, pseudopotential settings, special settings).
    `,
    titleP3:`
    Module: Based on the basic functions of PWmat, we have developed some top-level modules to meet user needs.
    This section provides an introduction to the functions of the modules.
    `,
    titleP4:`
    Utility: In order to facilitate the pre- and post-processing of calculations,
    the PWmat installation package comes with a series of utilities.
    Through these programs, we can realize the conversion between PWmat structure files
    and other common crystal structure files, process data to obtain visualized charge density,
    band structure diagram, projected state density, vacuum energy level and other operations.
    `,
    titleT2: 'Related Downloads',
    titleT2P1: 'download address',
    titleT2P2: 'Manual',
  }
}